import { MenuItem, Select, useBreakpoint } from '@vivino/js-react-common-ui';
import { VINTAGE_LIST_ID, getWineName, useI18N } from '@vivino/js-web-common';
import PropTypes from 'prop-types';
import React from 'react';
import { highlight, vintage, wine } from 'vivino-js/apiPropTypes';

import VintageListRow from './components/VintageListRow/VintageListRow.presentational';

import styles from './vintageList.scss';

const TRANSLATIONS = {
  sortBy: 'common.sort_by',
  compareVintages: 'components.shared.vintage_list.compare_vintages',
  compareVintagesMessage: 'components.shared.vintage_list.compare_vintages_message',
};

export const MAX_VINTAGES_ON_WINEPAGE = 5;

const VintageListPresentational = ({
  vintages,
  wine,
  pricesAndAvailabilities,
  highlights,
  isLoading,
  sortByOptions,
  onSortByChanged,
  sortByKey,
  isInModal = false,
}) => {
  const { isDesktop } = useBreakpoint();
  const { t } = useI18N();

  const findHighlightForVintageId = (vintageId) =>
    (highlights || []).find((highlight) => highlight.vintage_id === vintageId);

  return (
    <>
      <div id={VINTAGE_LIST_ID}>
        <h2>{t(TRANSLATIONS.compareVintages)}</h2>

        <>
          {!isInModal && (
            <div className={styles.compareVintagesMessage}>
              {t(TRANSLATIONS.compareVintagesMessage, {
                wine_name: getWineName(wine),
              })}
            </div>
          )}

          {!isLoading && (
            <div className={styles.menu}>
              <Select
                className={styles.wrapper}
                value={sortByKey}
                onChange={onSortByChanged}
                inputProps={{ 'aria-label': t(TRANSLATIONS.sortBy) }}
                native={!isDesktop}
                label={t(TRANSLATIONS.sortBy)}
              >
                {sortByOptions.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
            </div>
          )}

          {vintages.map((vintage) => {
            const availability = pricesAndAvailabilities[vintage.id]?.availability;
            const currency = pricesAndAvailabilities[vintage.id]?.market?.currency;

            return (
              <VintageListRow
                key={`vintage_row_${vintage.id}`}
                vintage={{ ...vintage, wine }}
                availability={availability}
                currency={currency}
                highlight={findHighlightForVintageId(vintage.id)}
                isInModal={isInModal}
              />
            );
          })}
        </>
      </div>
    </>
  );
};

VintageListPresentational.propTypes = {
  vintages: PropTypes.arrayOf(vintage).isRequired,
  wine: wine.isRequired,
  pricesAndAvailabilities: PropTypes.object.isRequired,
  highlights: PropTypes.arrayOf(highlight).isRequired,
  isLoading: PropTypes.bool.isRequired,
  showAll: PropTypes.bool,
  sortByOptions: PropTypes.array.isRequired,
  sortByKey: PropTypes.any.isRequired,
  onSortByChanged: PropTypes.func.isRequired,
  isInModal: PropTypes.bool,
};

export default VintageListPresentational;
